export default __webpack_public_path__ + "images/models/5b1b7b58ae7a3f5a27758aabaa332013.usdz";